import {inject} from 'aurelia-framework';
import Backend from "../backend";
import {activationStrategy, Router} from 'aurelia-router';

@inject(Backend, Router)
export class RecipeIndexScreen {
  backend;

  search;
  router;

  constructor(backend, router) {
    this.backend = backend;
    this.router = router;
  }

  activate(params) {
    this.search = params.search
    return Promise.all([
      this.refresh(params.search),
      this.backend.CmsFragmentPublicQueryHandler_handle({items: [
            {cmsFragmentKey: "recipe__section1"},
          ]})
        .then(result => {
          this.cmsFragments = result;
        }),
    ]);
  }

  submitSearch() {
    this.router.navigateToRoute("recipe-index", {
      search: this.search
    });
    return this.refresh(this.search)
  }

  refresh(search) {
    return this.backend.RecipeQueryHandler_handle({search: search})
      .then(result => this.recipes = result.items);
  }

  determineActivationStrategy() {
    return activationStrategy.replace;
  }
}